<template>
  <div>
    <job-preview-right-column
      :text-count-mode="textCountMode"
      :highlight-mode="highlightMode"
      :comment-highlights="commentHighlights"
      :text-counts="[getTextCount('求人名', title, targetIdMap.jobName)]"
      v-on="$listeners"
    />
    <div class="company-area">
      <h1
        :id="targetIdMap.jobName"
        class="fs16 hd-type-02 company-title clearfix"
        data-test="title"
        v-text="title"
      />
      <ul class="tags">
        <li>
          <ul class="icon">
            <li class="new">
              <img
                :src="`${userOfferImageUrlForPc}/icon_company_new.png`"
                alt="新着"
                data-test="new"
              >
            </li>
            <li
              v-if="isSimple && !isOriginalEntryForm"
              class="simple"
            >
              <img
                :src="`${userOfferImageUrlForPc}/icon_company_simple.png`"
                alt="シンプル"
                data-test="simple"
              >
            </li>
          </ul>
        </li>
        <span class="fs18">｜</span>
        <job-employment-status-pc :employment-status="employmentStatus" />
      </ul>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewRightColumn from '@/components/molecules/JobPreviewRightColumn'
import JobEmploymentStatusPc from '@/components/molecules/JobEmploymentStatusPc'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import jobPreviewHighlight from '@/lib/jobPreviewHighlight'

export default {
  components: {
    JobPreviewRightColumn,
    JobEmploymentStatusPc
  },
  mixins: [jobPreviewCommon, jobPreviewHighlight],
  props: {
    title: {
      type: String,
      required: true
    },
    isSimple: {
      type: Boolean,
      required: true
    },
    isOriginalEntryForm: {
      type: Boolean,
      required: true
    },
    employmentStatus: {
      type: Array,
      default: () => []
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      required: true
    },
    textCountMode: {
      type: Boolean,
      required: true
    }
  }
}
</script>
